import React from 'react';
import _ from 'lodash';
import autoBind from 'react-autobind';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import commonMessages from '@common/constraints/common.messages';
import textUtil from '@common/helpers/text.utils';
import Field from '@common/components/validation/field.validation';
import cpfCnpjValidator from '@common/validators/cpfCnpj.validator';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import * as formatterUtils from '@common/helpers/formatter.utils';
import { StyledMaskedTextBox } from './maskedTextBox.style';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);

    this.state = {
      customMask: undefined,
    };
    this.predefinedMasks = formatterUtils.predefinedMasks;
    this.isValid = false;
    autoBind(this);
  }

  get mask() {
    const { Mascara, dynamicMask, state, name } = this.props;

    if (this.state.customMask) return this.state.customMask;

    switch (Mascara) {
      case 'DYNAMIC':
        return !!dynamicMask
          ? dynamicMask.replace(/#/g, 9).replace(/A/g, 'a').replace(/\*/g, '*').replace(/"/g, '')
          : '';
      case 'CPF':
        return this.predefinedMasks.cpf.mask;
      case 'CNPJ':
        return this.predefinedMasks.cnpj.mask;
      case 'CPFCNPJ':
        return this.predefinedMasks.cpfCnpj.mask;
      case 'TELEFONE':
        const value = state && state[name] ? state[name].replace(/[^\d]+/g, '') : '';
        let mask = this.predefinedMasks.telefone.mask;
        if (value.length == 11) mask = this.predefinedMasks.telefone.maskCel;
        return mask.replace(/#/g, 9).replace(/A/g, 'a').replace(/\*/g, '*').replace(/"/g, '');
      case 'TELEFONEFAX':
        return this.predefinedMasks.telefoneFax.mask;
      case 'CEP':
        return this.predefinedMasks.cep.mask;
      case 'CAIXAPOSTAL':
        return this.predefinedMasks.caixapostal.mask;
      case 'NIT':
        return this.predefinedMasks.nit.mask;
      default:
        return Mascara.replace(/#/g, 9).replace(/"/g, '');
    }
  }

  get placeHolder() {
    const { Mascara, Placeholder, dynamicMask } = this.props;

    switch (Mascara) {
      case 'DYNAMIC':
        return !!dynamicMask ? dynamicMask.replace(/#/g, '_').replace(/A/g, '_').replace(/\*/g, '_') : '';
      case 'CPF':
        return this.predefinedMasks.cpf.placeHolder;
      case 'CNPJ':
        return this.predefinedMasks.cnpj.placeHolder;
      case 'CPFCNPJ':
        return this.predefinedMasks.cpfCnpj.placeHolder;
      case 'TELEFONE':
        return this.predefinedMasks.telefone.placeHolder.replace(/#/g, '_').replace(/A/g, '_').replace(/\*/g, '_');
      case 'TELEFONEFAX':
        return this.predefinedMasks.telefoneFax.placeHolder;
      case 'CEP':
        return this.predefinedMasks.cep.placeHolder;
      case 'CAIXAPOSTAL':
        return this.predefinedMasks.caixapostal.mask;
      case 'NIT':
        return this.predefinedMasks.nit.placeHolder;
      default:
        return Placeholder;
    }
  }

  //É necessário esse FIX por conta de Telefones Celulares com 9 dígitos
  fixForTelphoneFax(target) {
    let { value } = target;
    let isValid = false;
    let rawValue = target.element.value.replace(/[^\d]+/g, '');
    if (rawValue.length >= 10 && rawValue.length <= 11) {
      this.setState({ customMask: this.predefinedMasks.telefoneFax.maskCel });
    } else if (rawValue.length >= 12) {
      this.setState({ customMask: this.predefinedMasks.telefoneFax.maskFax });
    } else {
      this.setState({ customMask: this.predefinedMasks.telefoneFax.mask });
    }
    if (rawValue.length == 11 && this.mask != this.predefinedMasks.telefoneFax.maskCel) {
      this.setState({ customMask: this.predefinedMasks.telefoneFax.maskCel });
      value = rawValue.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
      isValid = true;
    } else if (rawValue.length >= 12 && this.mask != this.predefinedMasks.telefoneFax.maskFax) {
      this.setState({ customMask: this.predefinedMasks.telefoneFax.maskFax });
      value = rawValue.replace(/^(\d{3})(\d{5})(\d{5}).*/, '($1) $2-$3');
      isValid = true;
    } else if (rawValue.length < 11 && this.mask != this.predefinedMasks.telefoneFax.mask) {
      this.setState({ customMask: this.predefinedMasks.telefoneFax.mask });
      value = rawValue.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
      isValid = true;
    }
    return { value, isValid };
  }

  //Mascara dinamica para campos que aceitam cpf e cnpj
  cpfCnpjMask(target) {
    let { value } = target;
    let isValid = false;
    let rawValue = target.element.value.replace(/[^\d]+/g, '');

    if (rawValue.length <= 11 && this.mask != this.predefinedMasks.cpfCnpj.mask) {
      this.setState({ customMask: this.predefinedMasks.cpfCnpj.mask });
      value = formatterUtils.cpfFormatter(rawValue);
      textUtil.moveCursorToEnd(target.element);
      isValid = true;
    } else if (rawValue.length >= 12 && this.mask != this.predefinedMasks.cpfCnpj.maskCnpj) {
      this.setState({ customMask: this.predefinedMasks.cpfCnpj.maskCnpj });
      value = formatterUtils.cnpjFormatter(rawValue);
      textUtil.moveCursorToEnd(target.element);
      isValid = true;
    }

    return { value, isValid };
  }

  onChange(onChange) {
    return async (e) => {
      const { Mascara } = this.props;
      const { target } = e;
      this.isValid = target.validity.valid;

      let { value } = target;

      if (Mascara == 'TELEFONEFAX') {
        const fixedValues = this.fixForTelphoneFax(target);
        value = fixedValues.value;
        this.isValid = fixedValues.isValid;
      }

      if (Mascara == 'CPFCNPJ') {
        const fixedValues = this.cpfCnpjMask(target);
        value = fixedValues.value;
        this.isValid = fixedValues.isValid;
      }

      onChange(value);
    };
  }

  validate(value) {
    const { props, mask } = this;
    const { Mascara, noValidate, Obrigatorio } = props;

    if (noValidate) return;

    switch (Mascara) {
      case 'CPF':
        return !cpfCnpjValidator.validarCPF(value) ? commonMessages.validations.CPF_INVALID : undefined;
      case 'CNPJ':
        return !cpfCnpjValidator.validarCNPJ(value) ? commonMessages.validations.CNPJ_INVALID : undefined;
      case 'CPFCNPJ':
        const rawValue = value ? value.replace(/[^\d]+/g, '') : '';
        if (rawValue.length == 11)
          return !cpfCnpjValidator.validarCPF(value) ? commonMessages.validations.CPF_INVALID : undefined;
        else return !cpfCnpjValidator.validarCNPJ(value) ? commonMessages.validations.CNPJ_INVALID : undefined;
      case 'TELEFONEFAX':
        const telefonefaxValue = value ? value.replace(/[^\d]+/g, '') : '';
        return telefonefaxValue.length < 8 && telefonefaxValue != ''
          ? commonMessages.validations.TELEFONE_INVALID
          : undefined;
      case 'DYNAMIC':
      case 'TELEFONE':
        const valueDynamic = value ? value.replace(/[^\d]+/g, '') : '';
        const lengthMask = mask.replace(/[^\d]+/g, '').length;
        return valueDynamic.length != lengthMask && Obrigatorio
          ? commonMessages.validations.REQUIRED_IVALID
          : undefined;
      default:
        return;
    }
  }

  handleOnKeyDown(event) {
    const { Mascara, onKeyDown } = this.props;

    if (Mascara == 'TELEFONE') {
      const { value } = event.target;
      const isNumberKey = (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105);
      const keyValue = typeof event?.key == 'string' ? event.key : '';

      if (isNumberKey && keyValue) {
        const inputValue = value + keyValue;
        const rawValue = inputValue.replace(/[^\d]+/g, '');

        if (rawValue.length <= 10) {
          this.setState({ customMask: this.predefinedMasks.telefone.mask });
        } else if (rawValue.length == 11) {
          this.setState({ customMask: this.predefinedMasks.telefone.maskCel });
        }
      }
    }

    if (onKeyDown) onKeyDown(event);
  }

  renderComponent() {
    const { props, validate, mask, placeHolder } = this;
    const { Label, Tooltip, Obrigatorio, Desabilitado, name, dynamicMask, Mascara, PlacementTooltip } = props;
    const isDynamic = dynamicMask || Mascara == 'TELEFONE';

    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChangeAsync, onBlur, onFocus }) => {
          return (
            <span className={`${hasError ? 'span-input-invalid' : ''}`}>
              <LabeledInput {...props}>
                <OverlayTrigger
                  key={`top-${name}`}
                  placement={PlacementTooltip || 'top'}
                  overlay={
                    <TooltipBootstrap id={`tooltip-${name}`}>
                      <div className={'fontTooltip'}>{Tooltip || Label}</div>
                    </TooltipBootstrap>
                  }
                >
                  <div>
                    {!!isDynamic && (
                      <InputMask
                        alwaysShowMask
                        className="form-control"
                        name={name}
                        mask={mask}
                        placeholder={placeHolder}
                        value={value || ''}
                        disabled={Desabilitado}
                        required={Obrigatorio}
                        onChange={this.onChange(onChangeAsync)}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        onKeyDown={(event) => this.handleOnKeyDown(event)}
                      />
                    )}
                    {!isDynamic && (
                      <StyledMaskedTextBox
                        name={name}
                        mask={mask}
                        placeholder={placeHolder}
                        maskValidation={true}
                        validityStyles={false}
                        promptPlaceholder="true"
                        value={formatterUtils.formatter(value) || ''}
                        disabled={Desabilitado}
                        required={Obrigatorio}
                        onChange={this.onChange(onChangeAsync)}
                        onBlur={onBlur}
                        onFocus={onFocus}
                      />
                    )}
                  </div>
                </OverlayTrigger>
              </LabeledInput>
            </span>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control" readOnly>
                  {formatterUtils.formatter(field.value) || ''}
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{formatterUtils.formatter(field.value, this.props.Mascara) || ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
